import { Component, Input } from '@angular/core';

@Component({
  selector: 'fourqan-round-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() icon: string = '';
  @Input() color: string = '';
  @Input() disabled: boolean = false;

  constructor() {}
}
